import { render, staticRenderFns } from "./StatusCount.vue?vue&type=template&id=73dbf50a&scoped=true"
import script from "./StatusCount.vue?vue&type=script&lang=js"
export * from "./StatusCount.vue?vue&type=script&lang=js"
import style0 from "./StatusCount.vue?vue&type=style&index=0&id=73dbf50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dbf50a",
  null
  
)

export default component.exports